import { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';
import { ResponsiveValue, variant } from 'styled-system';
import { mapResponsive } from '../themes/responsive';
import Box from './Box';
import React from 'react';

type AspectRatioProps = {
  ratio: ResponsiveValue<number>;
};

const Wrapper = styled(Box)<AspectRatioProps & ComponentProps<typeof Box>>(({ ratio }: AspectRatioProps) =>
  variant({
    prop: 'variant',
    variants: {
      default: {
        ':before': {
          height: 0,
          pb: ratio,
          content: '""',
          display: 'block',
        },
        '> *:/home/osky/not(style)': {
          overflow: 'hidden',
          position: 'absolute',
          top: '0',
          right: '0',
          bottom: '0',
          left: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        },
        '> img, & > video': {
          objectFit: 'cover',
          objectPosition: 'center',
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
        },
      },
    },
  })
);

export const AspectRatio = ({ ratio = 4 / 3, children }: { ratio: ResponsiveValue<number>; children: ReactNode }) => {
  return (
    <Wrapper variant="default" ratio={mapResponsive(ratio, (x) => `${(1 / x) * 100}%`)}>
      {children}
    </Wrapper>
  );
};

AspectRatio.displayName = 'AspectRatio';
